import DropdownTemplateView from '../DropdownTemplateView'
import ScrollableContainer from '../util/ScrollableContainer'
import $ from 'jquery'
import ScrollUtils from '../util/ScrollUtils'

export default class ScrollableDropdownView extends DropdownTemplateView {
    constructor({
        component,
        disableFlip = false,
        onHide = () => {},
        onShow = () => {},
    }) {
        super(null, {
            toggleMode: false,
            onHide,
        })

        this.props = {
            component,
            disableFlip,
            onShow,
        }

    }

    templateHtml() {
        return '<div class="scrollableDropdownView">' +
               '</div>'
    }

    afterRender() {
        this.scrollableContainer = new ScrollableContainer(null, this.props.component).init(this.getEl())
        this.registerChildComponents(this.scrollableContainer )
    }

    setState(data) {
        this.applyForChildrenComponents(child => child.setState(data))
    }

    onShow() {
        super.onShow()
        this.scrollableContainer.forceUpdate()
        this.props.onShow()
    }

    showAt($element, positionParams, $positionEl) {
        if (this.props.disableFlip) {
            positionParams = {
                ...positionParams,
                collision: 'none'
            }
        }
        super.showAt($element, positionParams, $positionEl)
    }

    scrollTo(selector) {
        const $element = this.find(selector)
        if ($element.length > 0)
            this.scrollableContainer.scrollToElementVertical($element, ScrollUtils.POSITIONS.TOP)
    }

    mouseDownTargetElement() {
        return $('body')
    }

    _mouseDownIgnoreElement() {
        return this.$containerEl
    }

}



// WEBPACK FOOTER //
// ./web/js/components/ScrollableDropdownView.js